import React from 'react';

interface Badge {
  src: string;
  alt: string;
}

interface OneTrustBadgesProps {
  className?: string;
}

export function OneTrustBadges({ className = '' }: OneTrustBadgesProps) {
  const badges: Badge[] = [
    {
      src: "https://kebgtyzuvrqfytplwpwa.supabase.co/storage/v1/object/sign/website-images/OT%20BADGE%20PIC/Badge%201.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ3ZWJzaXRlLWltYWdlcy9PVCBCQURHRSBQSUMvQmFkZ2UgMS5wbmciLCJpYXQiOjE3NDM2OTUyNTIsImV4cCI6MjA1OTA1NTI1Mn0.ltgIGYvnsMW2JLwwkAiS-f1W-k9CcRYNdiYRHfKEadQ",
      alt: "OneTrust Badge 1"
    },
    {
      src: "https://kebgtyzuvrqfytplwpwa.supabase.co/storage/v1/object/sign/website-images/OT%20BADGE%20PIC/Badge%202.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ3ZWJzaXRlLWltYWdlcy9PVCBCQURHRSBQSUMvQmFkZ2UgMi5wbmciLCJpYXQiOjE3NDM2OTUyOTQsImV4cCI6MjA1OTA1NTI5NH0.gh7QrUSqjD6_1RyI5nAKbPBg2MeasQAdqLb3r5SmO0w",
      alt: "OneTrust Badge 2"
    },
    {
      src: "https://kebgtyzuvrqfytplwpwa.supabase.co/storage/v1/object/sign/website-images/OT%20BADGE%20PIC/badge%203.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ3ZWJzaXRlLWltYWdlcy9PVCBCQURHRSBQSUMvYmFkZ2UgMy5wbmciLCJpYXQiOjE3NDM2OTUzMjcsImV4cCI6MjA1OTA1NTMyN30.9AGbDt1zunFvyL0BdBFxyA9CdKi4nm5qAF8X8Q6XQis",
      alt: "OneTrust Badge 3"
    },
    {
      src: "https://kebgtyzuvrqfytplwpwa.supabase.co/storage/v1/object/sign/website-images/OT%20BADGE%20PIC/badge%204.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ3ZWJzaXRlLWltYWdlcy9PVCBCQURHRSBQSUMvYmFkZ2UgNC5wbmciLCJpYXQiOjE3NDM2OTUzNTQsImV4cCI6MjA1OTA1NTM1NH0.nXuohc1pyafr5N7k3nPe9TIe8OshhiIgGGQ1Bsp9mlM",
      alt: "OneTrust Badge 4"
    },
    {
      src: "https://kebgtyzuvrqfytplwpwa.supabase.co/storage/v1/object/sign/website-images/OT%20BADGE%20PIC/Badge%205.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ3ZWJzaXRlLWltYWdlcy9PVCBCQURHRSBQSUMvQmFkZ2UgNS5wbmciLCJpYXQiOjE3NDM2OTUzODEsImV4cCI6MjA1OTA1NTM4MX0.KkqsX6Gfsd_hYMGo_QTIZMKQzw14IlPT1QyKx6Em_8Q",
      alt: "OneTrust Badge 5"
    },
    {
      src: "https://kebgtyzuvrqfytplwpwa.supabase.co/storage/v1/object/sign/website-images/OT%20BADGE%20PIC/Badge%206.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ3ZWJzaXRlLWltYWdlcy9PVCBCQURHRSBQSUMvQmFkZ2UgNi5wbmciLCJpYXQiOjE3NDM2OTU1MTEsImV4cCI6MjA1OTA1NTUxMX0.7KzUtYEoQAT7sc2HEsAKFN3ISPoTVs7Rn375fS--bFk",
      alt: "OneTrust Badge 6"
    },
    {
      src: "https://kebgtyzuvrqfytplwpwa.supabase.co/storage/v1/object/sign/website-images/OT%20BADGE%20PIC/Badge%207.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ3ZWJzaXRlLWltYWdlcy9PVCBCQURHRSBQSUMvQmFkZ2UgNy5wbmciLCJpYXQiOjE3NDM2OTU3NDMsImV4cCI6MjA1OTA1NTc0M30.fiQta-hc6tVxmKkBFbpQOc0kqxjOgFwmUK7KUHjASYw",
      alt: "OneTrust Badge 7"
    },
    {
      src: "https://kebgtyzuvrqfytplwpwa.supabase.co/storage/v1/object/sign/website-images/OT%20BADGE%20PIC/Badge%208.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJ3ZWJzaXRlLWltYWdlcy9PVCBCQURHRSBQSUMvQmFkZ2UgOC5wbmciLCJpYXQiOjE3NDM2OTU3ODAsImV4cCI6MjA1OTA1NTc4MH0.KpZdKHe4fqHEGCQLJq95Qaqd8sn9C_7tyEDASzZ-hiE",
      alt: "OneTrust Badge 8"
    }
  ];

  return (
    <div className={`mt-24 flex justify-center items-center gap-4 flex-wrap ${className}`}>
      {badges.map((badge, index) => (
        <div 
          key={index}
          className="w-24 h-24 flex items-center justify-center transform hover:scale-110 transition-all duration-300"
        >
          <img
            src={badge.src}
            alt={badge.alt}
            className="w-full h-full object-contain"
          />
        </div>
      ))}
    </div>
  );
}